module.exports = __webpack_public_path__ + "static/media/create_customer.fe7dcbd1.svg";